module.exports = "/_next/static/images/not_found-9a806946feeb5845a9240befaaf7b25d.svg";